(function () {
  // Only for collection pages
  if (!document.body.classList.contains('template-collection')) return;

  const body = document.body;
  const SCROLL_THRESHOLD = 10;

  const updateHeaderState = () => {
    if (window.scrollY <= SCROLL_THRESHOLD) {
      // Top of page → hide header
      body.classList.add('hide-header');
      body.classList.remove('has-scrolled');
    } else {
      // Scrolled → show header
      body.classList.add('has-scrolled');
      body.classList.remove('hide-header');
    }
  };

  // Initial state
  updateHeaderState();

  // Scroll listener
  window.addEventListener('scroll', updateHeaderState, { passive: true });

  // Shopify AJAX safety (filters, pagination)
  document.addEventListener('shopify:section:load', updateHeaderState);
})();
